/**
 * @class {Fuction} Popover
 * @author yongbigang
 * @date 16/9/1
 */

'use strict';

var Popover = function(options){

  this.container = options.container ? options.container : '#ad-popover';
  this.to = options.to ? options.to : '';
  this.width = $(window).width();
  this.height = $(window).height();
  this.time = options.time ? options.time : 3;
  this.etagType = options.etagType ? options.etagType : 'day'; //second
  this.etag = options.etag ? options.etag : 1;

};

Popover.prototype = {
  init: function(){

    if(!this.expires(this.etag)) return;

    var alias = this;
    $(this.container).show();
    $(this.container + '-bg').show();

    if ($(this.to).length > 0) {
      this.width = $(this.to).offset().left + parseInt($(this.to).width() / 2);
      this.height = $(this.to).offset().top + parseInt($(this.to).height() / 2);
    }

    setTimeout(function(){
      alias.ani(alias.height,alias.width);
    },this.time * 1000);

    $(this.container + ' .close').on('click',function(){
      alias.ani(alias.height,alias.width);
    });

  },
  ani: function(h,w){
    $(this.container).animate({
      opacity: 0,
      width:0,
      top: h,
      left: w
    });
    $(this.container + '-bg').hide();
  },
  expires: function(day){
    var show = true;

    if(window.localStorage){
      var _oldExpires = parseInt(localStorage.getItem('popover-expires'));
      if(_oldExpires){
        var _newExpires = new Date().getTime();
        var _diff = _newExpires - _oldExpires;
        var _condition = day * 24 * 60 * 60 * 1000;
        if(this.etagType != 'day') _condition = day * 1000;

        if(_diff < _condition) show = false;
        else window.localStorage.setItem('popover-expires',_newExpires);
      }else{
        window.localStorage.setItem('popover-expires',new Date().getTime());
      }
    }

    return show;
  }
};

module.exports = Popover;



// WEBPACK FOOTER //
// ./lib/js/public/popover.js